import { Injectable } from "@angular/core";
@Injectable()
export class ViewModel {

  // private _dialogId: number = -1;
  //
  // private _conversationListPage: number = 1;

  private params: Map<string, object>;

  constructor() {
    this.params = new Map<string, object>();
  }

  set(key: string, value: any): void {
    this.params.set(key, value);
  }

  get(key: string): object {
    if (this.params.has(key)) {
      return this.params.get(key);
    }

    return null;
  }

  // set conversationListPage(value: number) {
  //   this._conversationListPage = value;
  // }
  //
  // get conversationListPage(): number {
  //   return this._conversationListPage;
  // }
  //
  // get dialogId(): number {
  //   return this._dialogId;
  // }
  //
  // set dialogId(value: number) {
  //   this._dialogId = value;
  // }

}
